import { LayerDefinition } from './types';

export const cloudsDefinition: LayerDefinition = {
  id: 'clouds',
  name: 'Cloud Cover',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '☁️',
  description: 'High, Mid, Low, and Total Cloud fraction grids. Use this map to see where various weather models are predicting clouds.',
  sourceModels: ['ecmwf', 'gfs', 'hrrr', 'rdps', 'rrfs', 'icon13'],
  outputModels: ['Multi-layer .pmtiles grids per model (Low, Mid, High, Total)'],
  config: {
    levels: ['total', 'low', 'mid', 'high'],
    defaultModel: 'ecmwf'
  }
};

export default cloudsDefinition;
